module.exports = __webpack_public_path__ + "static/media/close-modal.e8a89386.svg";